<template>
    <div>
        <div class="nav">
            <p>收益明细</p> 
        </div>
        <van-icon name="arrow-left"  class="icon" @click="icon"/>
        <div class="top">
            <p>{{info.user_nicename}} 购买 {{info.name}}}</p>
            <p>+{{money.gains}}</p>
        </div>
        <div class="btu">
            <ul>
                <li>消费编号</li>
                <li>消费商品</li>
                <li>消费顾客</li>
                <li>消费金额</li>
                <li>消费时间</li>
            </ul>
            <ul>
                <li>{{info.order_num}}</li>
                <li>{{info.name}}</li>
                <li>{{info.user_nicename}}</li>
                <li>￥{{info.pay_amount}}</li>
                <li>{{info.create_time}}</li>
            </ul>
        </div>
    </div>
</template>

<script>
import URL from '../../api/index'
import Vue from 'vue';
import { Icon } from 'vant';

Vue.use(Icon);
export default {
    data(){
        return{
            money:[],
            info:[]
        }
    },
    mounted(){
        let num=this.$route.query.num
        console.log(num);
        this.postmoney(num)
    },
    methods:{
        icon(){
            this.$router.go(-1)
        },
        postmoney(e){
            this.$axios({
                method:'post',
                url:URL.gainsinfo,
                data:{
                    token:'c4ca4238a0b923820dcc509a6f75849b',
                    ordernum:e
                }
                }).then((res) =>{
                    console.log(res);  
                    this.money = res.data.result
                    console.log(this.money);
                    this.info = res.data.result.info
                })
        }
    }
}
</script>

<style scoped>
* {
    margin: 0;
    padding: 0;
}

.icon{
    vertical-align: middle;
    position: fixed;
    line-height: 46px;
    left: 15px;
    top: 0;
    color: #fff;
    z-index: 2
}
.nav{
    width: 100%;
    background-image: linear-gradient(to right, #406df8 , #6289fe);
    line-height: 46px;
    text-align: center;
    color: #fff;
    vertical-align: middle;
}

.top{
    padding: 15px;
    border-bottom: 1px solid #e5e5e5;
}
.top p:first-child{
	font-size: 18px;
	color: #000000;
    text-align: center;
    line-height: 52px;
    overflow:hidden;
    white-space:nowrap;
    text-overflow:ellipsis;
}
.top p:last-child{
	font-size: 30px;
	color: #ed3638;
    text-align: center;
    line-height: 78px;
}
.btu{
    padding: 15px 30px;
}
ul{
    display: inline-block;
}
ul:first-child{ 
	font-size: 14px;
	line-height: 30px;
	color: #82848a;
    margin-right: 10px;
}
ul:last-child{
	font-size: 13px;
	line-height: 30px;
	color: #000;
}
</style>



// WEBPACK FOOTER //
// src/pages/withdrawal/withdrawal.vue